import React from "react";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select as MuiSelect,
  withStyles,
  createStyles,
  Theme,
  Checkbox,
  ListItemText
} from "@material-ui/core";
import { Classes } from "jss";
import classNames from "../../utils/classNames";

type Props = {
  classes: Classes;
  className?: string;
  label: string;
  id: string;
  options: {
    value: string | number;
    label: string;
  }[];
  onChange: (e: any) => void;
  multiple?: boolean;
  disabled?: boolean;
  renderValue?: (selected: any) => string;
  value: string | number | any[];
};

const styles = (theme: Theme) =>
  createStyles({
    root: {
      minWidth: "150px"
    }
  });

const Select = ({
  classes,
  className,
  id,
  label,
  options,
  onChange,
  value,
  multiple,
  disabled,
  renderValue
}: Props) => {
  return (
    <FormControl className={classNames(classes.root, className)}>
      <InputLabel htmlFor={id}>{label}</InputLabel>
      <MuiSelect
        data-test-control={id}
        value={value}
        multiple={multiple}
        disabled={disabled}
        renderValue={renderValue}
        onChange={onChange}
        inputProps={{
          name: label,
          id: id
        }}
      >
        {options.map(opt => (
          <MenuItem key={opt.value} value={opt.value}>
            {!multiple ? (
              opt.label
            ) : (
              <>
                <Checkbox checked={(value as any[]).indexOf(opt.value) > -1} />
                <ListItemText primary={opt.label} />
              </>
            )}
          </MenuItem>
        ))}
      </MuiSelect>
    </FormControl>
  );
};

const styled = withStyles(styles)(Select);
export { styled as Select };
